<template>
  <div>
    <template v-if="!isEditing">
      {{ numeroNotaFiscal | naoInformado }}
      <v-btn :disabled="disabled"
             icon
             :small="small"
             @click="onClickEdit">
        <v-icon :size="size">mdi-pencil</v-icon>
      </v-btn>
    </template>
    <template v-else>
      <v-text-field
        autofocus
        dense
        hide-details
        maxlength="200"
        class="rounded-tag-small"
        v-on:keyup.enter="onClickSave"
        v-model="numeroNotaFiscal"
      >
        <template v-slot:append-outer>
          <v-btn icon
                 :small="small"
                 :loading="loading"
                 @click="onClickSave">
            <v-icon :size="size">mdi-check</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </template>
  </div>
</template>

<script>
import CompraService from '@/modules/compra/compra-service';

export default {
  props: {
    compra: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '20',
    },
  },
  data() {
    return {
      numeroNotaFiscal: null,
      isEditing: false,
      loading: false,
    };
  },
  methods: {
    onClickSave() {
      this.saveNumeroNotaFiscal();
    },
    onClickEdit() {
      this.isEditing = true;
    },
    saveNumeroNotaFiscal() {
      this.loading = true;
      CompraService.updateCompra({
        id: this.compra.id,
        numeroNotaFiscal: this.numeroNotaFiscal,
      })
        .then(() => {
          this.isEditing = false;
        }).finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.numeroNotaFiscal = this.compra.numeroNotaFiscal;
  },
};
</script>
